import { reactive } from 'vue';

import { IActState } from '@/models/act/store/state.interface';
import { ModalActAccessStates } from '@/models/modal/modal.enum';
import { ProjectProductState } from '@studyportals/crm-data-processor-interface';

const actState: any = reactive({
	actAccessEntries: [],
	actAvailableDashboards: [],
	actDashboardsToAdd: [],
	actSameDateForDashboards: true,
	actUsersToAdd: [],
	modalActAccessState: ModalActAccessStates.INACTIVE,
	selectedActFilterOption: ProjectProductState.Unprocessed,
	selectedActInvoiceNumber: 0
});

export default actState as IActState;
